<app-header-list titulo="Lista de Projetos"/>

<ion-content [fullscreen]="true">
    <p-table [lazy]="true" (onLazyLoad)="load($event)" #dt1 styleClass="p-datatable-striped" sortMode="multiple"
             [showCurrentPageReport]="true" responsiveLayout="scroll"
             currentPageReportTemplate="{first}-{last}/{totalRecords}"
             [pageLinks]="0" [totalRecords]="total"
             [rows]="100" [paginator]="true"  dataKey="id" [value]="entidades">
      <ng-template pTemplate="header">
        <tr style="vertical-align: top">
          <th pSortableColumn="nome"> Nome<br/>
            <div>
              <p-sortIcon field="nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="nome"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="inicio"> Início<br/>
            <div>
              <p-sortIcon field="inicio"></p-sortIcon>
              <p-columnFilter display="menu" type="date" field="inicio"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="fim"> Fim<br/>
            <div>
              <p-sortIcon field="fim"></p-sortIcon>
              <p-columnFilter display="menu" type="date" field="fim"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="local.nome"> Local<br/>
            <div>
              <p-sortIcon field="local.nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="local.nome"></p-columnFilter>
            </div>
          </th>

          <th > Grupos<br/>
            <div>
              <p-columnFilter matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                              [showAddButton]="false" field="metodologias.grupo">
                <ng-template pTemplate="filter" let-gruposSelecionados let-filter="filterCallback">
                  <p-multiSelect [ngModel]="gruposSelecionados"
                                 [options]="grupos" (onChange)="filter($event.value)"
                                 [filter]="false" placeholder="Qualquer">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr routerLink="edit/{{item.id}}" style="cursor: pointer">
          <td>{{item.nome}}</td>
          <td>{{item.inicio  | date: 'dd/MM/yy'}}</td>
          <td>{{item.fim  | date: 'dd/MM/yy'}}</td>
          <td>{{item.local?.nome}}</td>
          <td>{{this.retornaGrupos(item)}}</td>
        </tr>
      </ng-template>
    </p-table>
    <ion-fab slot="fixed"  vertical="bottom" horizontal="end">
      <ion-fab-button routerLink="new" color="success">
        <ion-icon  name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
</ion-content>

<app-rodape [exibirBotoes]="false"/>
